<template>
  <div class="bus">
    <div class="bus__left">
      <div class="bus__left__header">
        <div class="form-group">
          <div class="input">
            <input type="text" v-model="search" required>
            <label class="base-font">Search route</label>
          </div>
        </div>
      </div>
      <div class="bus__left__body">
        <div class="bus__left__body__menu" v-if="search == ''">
          <ul>
            <li class="base-font to-uppercase" :class="{active: menuActive(category.id)}" v-for="(category, index) in categories" :key="index" @click.stop="filterCategory(category.id)">{{category.label}}</li>
          </ul>
        </div>
        <template v-if="isLoading">
          <div class="loading">
            <adx-loading-primary />
          </div>
        </template>
        <template v-else>
          <template v-if="search == ''">
            <div class="bus__left__body__table">
              <div class="header" v-if="!isEmpty">
              <table>
                <thead>
                  <tr>
                    <td class="route">ROUTE</td>
                    <td class="trip">TRIP</td>
                    <td class="traffic">TRAFFIC/DAY</td>
                  </tr>
                </thead>
              </table>
              </div>
              <div class="body" v-if="!isEmpty">
              <table>
                <tbody>
                  <template>
                    <tr v-for="(route, index) in routes" :key="index" @click.stop="openDetail(route.id)" @mouseover="changeRoute(index)">
                      <td class="route">{{route.title}}</td>
                      <td class="trip">{{route.daily_trip}}</td>
                      <td class="traffic">{{route.traffic}}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
              </div>
              <div class="emptyState" v-if="isEmpty">
                <adx-empty-selection v-if="isEmpty"/>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="bus__left__body__table">
              <div class="header" v-if="!isEmpty">
              <table class="search">
                <thead>
                  <tr>
                    <td class="route">ROUTE</td>
                    <td class="trip">TRIP</td>
                    <td class="traffic">TRAFFIC/DAY</td>
                  </tr>
                </thead>
              </table>
              </div>
              <div class="body" v-if="!isEmpty">
              <table class="search">
                <tbody v-for="(category, index) in categories" :key="index">
                  <template v-if="getRouteByCategory(category).length > 0">
                    <tr >
                      <td colspan="3">
                        {{category.label}}
                      </td>
                    </tr>
                    <template v-for="(route, index) in routes">
                      <tr v-if="route.categories.id == category.id" :key="`${route.id}${index}`" @click.stop="openDetail(route.id)" @mouseover="changeRoute(index)">
                        <td class="route">{{route.title}}</td>
                        <td class="trip">{{route.daily_trip}}</td>
                        <td class="traffic">{{route.traffic}}</td>
                      </tr>
                    </template>
                  </template>
                </tbody>
              </table>
              </div>
              <div class="emptyState" v-if="isEmpty">
                <adx-empty-selection v-if="isEmpty"/>
              </div>
            </div>
          </template>
        </template>
      </div>
    </div>
    <div class="bus__right">
      <button class="closemapmobile" @click.stop="toggleMap" :class="{mobile: isOpenMapMobile}">x</button>
      <GmapMap
        :class="{mobile: isOpenMapMobile}"
        class="adx-map"
        :center="{lat:-6.1944935, lng:106.7643612}"
        :zoom="12"
        map-type-id="terrain"
        style="width: 100%; position: absolute;top: 0; left: 0;right: 0;bottom: 0"
        ref="mapRef"
        :options="{
          zoomControl: true,
          mapTypeControl: true,
          streetViewControl: false,
          rotateControl: false,
          fullscreenControl: false,
          disableDefaultUi: false
        }"
      >
      </GmapMap>

      <div class="orderSummary" :class="{summaryActive : isOpenSummaryMobile}">
        <div class="orderSummary__title">
          <h2>Order Summary</h2>
        </div>
        <!-- <div class="orderSummary__top"> -->
          <div class="orderSummary__header">
            <adx-selectdropdown :label="`Period of Campaign`" :value.sync="model.campaignInfo.period" :options="dropdown" @selected="selectedPeriod"/>
            <div class="calendar">
              <v-date-picker
                v-model='model.campaignInfo.start'
                :popoverVisibility="'focus'"
                :min-date='aWeekLater'
                :theme-styles='themeStyles'
                class='date-picker'>
                <div class="field"
                  slot-scope='{ inputValue, updateValue }'
                >
                  <input
                    class="date-picker-input"
                    type='text'
                    required
                    readonly
                    :value='inputValue'
                    @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                    @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                    <label class="subhead calendar-label">Start Date</label>
                </div>
              </v-date-picker>
            </div>
          </div>
          <div class="orderSummary__content">
            <div class="orderSummary__content__item" v-for="(item, index) in order" :key="index">
              <div class="orderSummary__content__item__header">
                <div class="orderSummary__content__item__header__left">
                  <h6 class="small-font font-12__weightBold">{{item.detail.title}}</h6>
                  <h6 v-if="item.generic" class="small-font color-grey font-12">{{item.generic.title}}</h6>
                </div>
                <div class="orderSummary__content__item__header__right small-font color-pink font-12__weightBold">
                  {{(item.generic.price * item.count * model.campaignInfo.period) | formatMoney}}
                </div>
              </div>
              <div class="orderSummary__content__item__body  ">
                <div class="orderSummary__content__item__body__left">
                  <adx-selectdropdown class="buscount" :size="`small`" :options="dropdownBus" :value.sync="item.count" :selected="selectedValue(item)" />
                </div>
                <div class="orderSummary__content__item__body__right">
                  <i class="icon-deleted" @click="deleteOrder(index)"></i>
                </div>
              </div>
              <div class="orderSummary__content__item__footer">

              </div>
            </div>
          </div>
        <!-- </div> -->
        <div class="orderSummary__footer">
          <div v-if="isLoadingCampaign">
            <adx-loading-spin slot="loading"/>
          </div>
          <div v-else>
            <div v-if="order.length < 1" class="orderSummary__footer__default">
              Please select route and your advestising type to add an order 
            </div>
            <div v-else class="orderSummary__footer__exist">
              <div class="orderSummary__footer__ppn">
                <h2 class="small-font font-12">PPN 10%</h2>
                <h2 class="small-font price color-pink font-12">{{(0.1 * getTotal()) | formatMoney}}</h2>
              </div>
              <div class="orderSummary__footer__total">
                <h2 class="small-font font-12">Total Order</h2>
                <h1 class="price large-font color-pink">{{getTotalByPPN() | formatMoney}}</h1>
              </div>
            </div>
          </div>
          <template v-if='screen >= 575'>
            <button class="primary btn-block" @click.stop="submit" :disabled="isLoadingContinue || order.length < 1 || isLoading">
              Continue
              <div class="primary__load">
                <adx-loading-spin v-if="isLoadingContinue" slot="loading"/>
              </div>
            </button>
          </template>
          <template v-else>
            <div class="continueMobile">
              <button class="primary btn-block" @click.stop="submit" :disabled="isLoadingContinue || order.length < 1 || isLoading">
                Continue
                <div class="primary__load">
                  <adx-loading-spin v-if="isLoadingContinue" slot="loading"/>
                </div>
              </button>
              <button class="secondary btn-block" @click.stop="addMoreOrder" :disabled="isLoadingContinue  || isLoading">
                Add More
                <div class="primary__load">
                  <adx-loading-spin v-if="isLoadingContinue" slot="loading"/>
                </div>
              </button>
            </div>
          </template>
        </div>
      </div>
    </div>
    <transition name="slide-fade">
      <div class="bus__detail" v-if="isOpenDetail" :class="{ mobile : isOpenDetailMobile }">
        <div class="bus__detail__overlay"></div>
        <div class="bus__detail__content">
          <div class="header">
            <div class="header__inline--between">
              <h6>{{getDetail().title}}</h6>
              <i @click.stop="closeDetail" class="icon-close"></i>
            </div>
            <div class="header__inline">
              <div class="box">
                <h3>{{getDetail().daily_trip | formatNumber}} daily trip</h3>
                <h3>{{getDetail().traffic | formatNumber}} traffic/day</h3>
              </div>
              <div class="box">
                <h3>{{seat}} seats</h3>
                <h3>{{getDetail().categories.title}}</h3>
              </div>
            </div>
          </div>
          <div class="top">
            <div class="top__space">
              <div class="top__space__header">
                <p>ADVERTISING SPACE</p>
              </div>
              <div class="top__space__content">
                <div class="item" v-for="(detail, index) in details.generics" :key="index">
                  <div class="item__header">
                    <div class="space-1"></div>
                    <div>
                      <h2 class="regular-font">{{detail.title}}</h2>
                    </div>
                  </div>
                  <div class="item__content">
                    <div class="space-1">
                      <div class="radio">
                        <input :id="`space${index}`" name="grup" :value="detail.id" type="radio" v-model="picked">
                        <label class="subhead" :for="`space${index}`"></label>
                      </div>
                    </div>
                    <ul>
                      <li>
                        <div class="space-2">
                          <img v-if="details.content && details.content[index].contents[0]" :src="details.content[index].contents[0].content_url" alt="">
                          <!-- <img v-else-if="true" :src="`/img/bus/full_back.png`"> -->
                          <img v-else :src="`/img/bus/half_body.png`">
                        </div>
                      </li>
                      <li>
                        <div class="space-3">
                          <p>{{detail.description}}</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div class="item__footer">
                    <div class="space-1"></div>
                    <div>
                      <p class="color-black mini-font">Price per month</p>
                      <h2 class="color-red medium-title">{{detail.price | formatMoney}}</h2>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <div class="top__router">
              <div class="top__router__header">
                <p>ROUTER DETAILS</p>
              </div>
              <div class="top__router__content">
                <ul class="line">
                  <li v-for="(route, index) in getDetail().routeDetails" :key="index" class="subhead">{{route.location}}</li>
                </ul>
              </div>
            </div>
            <div class="top__forbiden">
              <div class="top__forbiden__header">
                <p>CONTENT RESTRICTIONS</p>
              </div>
              <div class="top__forbiden__content">
                <p>{{getDetail().forbiddenAds}}</p>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="bottom__footer">
              <button :disabled="picked == null" class="btn-block primary" @click.stop="addOrder()">Add to Order</button>
            </div>
          </div>
        </div>
        <div class="openMap" @click.stop="toggleMap" v-if="screen <= 575">
          <!-- <button>Map</button> -->
          <img class="iconMap" :src="`/img/bus/ic_map@2x.png`"/>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {gmapApi} from 'vue2-google-maps'
import Radio from '@/components/Form/Radio'
import Input from '@/components/Form/Input'
import SelectDropdown from '@/components/Form/SelectDropdown'
import LoadingPrimary from '@/components/Loading/Primary'
import LoadingSpin from '@/components/Loading/Secondary'
import EmptySelection from '@/components/NotFound/Selection'
import Media from 'vue-media'

import moment from 'moment'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { parseErrorGql } from '@/lib/error'
import * as validationLib from '@/lib/validation/'
const {
  helpers,
  validate
} = validationLib


export default {
  name: 'adx-bus',
  components: {
    'adx-empty-selection': EmptySelection,
    'adx-input': Input,
    'adx-selectdropdown': SelectDropdown,
    'adx-radio': Radio,
    'adx-loading-primary': LoadingPrimary,
    'adx-loading-spin': LoadingSpin,
    'media': Media
  },
  props: {

  },
  data() {
    return {
      screen: window.innerWidth,
      isOpenDetailMobile: false,
      isOpenSummaryMobile: false,
      isOpenMapMobile: false,
      countCheckout:0,
      countRoute:0,
      detailId: null,
      isEmpty: false,
      isInit: true,
      isLoading: false,
      isLoadingCampaign: false,
      isLoadingContinue: false,
      isOpenDetail: false,
      lastSource: 0,
      location: null,
      map: null,
      minimumLeadTime:0,
      minimumPeriod:0,
      picked: null,
      results: null,
      seat: null,
      source: 0,

      arr: [],
      details: [],
      order: [],
      routes: [],
      style: [],
      category: '1',
      search: '',
      
      model: {
        campaignInfo: {
          start: null,
          period: null
        },
        orderRoutes: []
      },
      categories: [
        {
          id: '1',
          label: 'Airport Bus'
        },
        {
          id: '2',
          label: 'City Bus'
        },
        {
          id: '3',
          label: 'Transjabodetabek'
        },
      ],
      dropdown: [
        {
          label: '1 Month',
          value: 1
        },
        {
          label: '2 Months',
          value: 2
        },
        {
          label: '3 Months',
          value: 3
        },
        {
          label: '4 Months',
          value: 4
        },
        {
          label: '5 Months',
          value: 5
        },
        {
          label: '6 Months',
          value: 6
        },
        {
          label: '7 Months',
          value: 7
        },
        {
          label: '8 Months',
          value: 8
        },
        {
          label: '9 Months',
          value: 9
        },
        {
          label: '10 Months',
          value: 10
        },
        {
          label: '11 Months',
          value: 11
        },
        {
          label: '12 Months',
          value: 12
        }
      ],
      dropdownBus: [

      ],
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
    }
  },
  computed: {
    google: gmapApi,
    aWeekLater() {
      var aWeekLater = new Date();
      if (this.minimumLeadTime>7){
        aWeekLater.setDate(aWeekLater.getDate() + this.minimumLeadTime);
      } else{
        aWeekLater.setDate(aWeekLater.getDate() + 7);
      }
      // aWeekLater.setDate(aWeekLater.getDate() + 7);
      return aWeekLater
    },
    ...mapGetters({
      token: 'token'
    })
  },
  apollo: {

  },
  watch: {
    source(x, y) {
      this.lastSource = y
      if(this.$refs.mapRef){
        this.$refs.mapRef.$mapPromise.then((map) => {
          let z = this.arr[parseInt(x)];
          let w = this.arr[parseInt(y)];
          if(w){
            w.setMap(null);
          }
          if(z){
            z.setMap(map);
          }
        });
      }
    },
    async picked(){
      const detail = await this.getDetail()
      const bus = await this.details.content.filter(x => {
        return x.generic != null && x.generic.id == this.picked
      })
      let busPicked = bus.pop()
      if (busPicked) this.seat = busPicked.seats
    },
    google() {
      this.loadData()
    },
    category() {
      // this.isLoading = true
      //call this again because query in method is not reactive
      // this.getRoutes()
      this.initData()
    },
    search: helpers.debounce(function (x, y) {
      this.$nextTick(function () {
        if(x == ''){
          this.category = '1'
          // this.debounceinitData()
          this.debouncerefetchData()
        }else {
          // this.debouncegetDataSearch()
          this.debouncerefetchDataSearch()
        }
      })
    }, 500),
  },
  beforeCreate() {

  },
  created() {

    this.debounceinitData = _.debounce(this.initData, 1000)
    this.debouncegetDataSearch = _.debounce(this.getDataSearch, 1000)
    this.debouncerefetchData = _.debounce(this.refetchData, 1000)
    this.debouncerefetchDataSearch = _.debounce(this.refetchDataSearch, 1000)

    this.getValueMaxBus()
  },
  beforeMount() {

  },
  async mounted() {
    this.initData()
    this.getRoutes()
    // let styledMapType = new google.maps.StyledMapType(
    //         [
    //             {
    //                 "featureType": "landscape.man_made",
    //                 "elementType": "geometry",
    //                 "stylers": [
    //                     {
    //                         "color": "#f7f1df"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "landscape.natural",
    //                 "elementType": "geometry",
    //                 "stylers": [
    //                     {
    //                         "color": "#d0e3b4"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "landscape.natural.terrain",
    //                 "elementType": "geometry",
    //                 "stylers": [
    //                     {
    //                         "visibility": "off"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "poi",
    //                 "elementType": "labels",
    //                 "stylers": [
    //                     {
    //                         "visibility": "off"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "poi.business",
    //                 "elementType": "all",
    //                 "stylers": [
    //                     {
    //                         "visibility": "off"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "poi.medical",
    //                 "elementType": "geometry",
    //                 "stylers": [
    //                     {
    //                         "color": "#fbd3da"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "poi.park",
    //                 "elementType": "geometry",
    //                 "stylers": [
    //                     {
    //                         "color": "#bde6ab"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "road",
    //                 "elementType": "geometry.stroke",
    //                 "stylers": [
    //                     {
    //                         "visibility": "off"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "road",
    //                 "elementType": "labels",
    //                 "stylers": [
    //                     {
    //                         "visibility": "off"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "road.highway",
    //                 "elementType": "geometry.fill",
    //                 "stylers": [
    //                     {
    //                         "color": "#ffe15f"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "road.highway",
    //                 "elementType": "geometry.stroke",
    //                 "stylers": [
    //                     {
    //                         "color": "#efd151"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "road.arterial",
    //                 "elementType": "geometry.fill",
    //                 "stylers": [
    //                     {
    //                         "color": "#ffffff"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "road.local",
    //                 "elementType": "geometry.fill",
    //                 "stylers": [
    //                     {
    //                         "color": "black"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "transit.station.airport",
    //                 "elementType": "geometry.fill",
    //                 "stylers": [
    //                     {
    //                         "color": "#cfb2db"
    //                     }
    //                 ]
    //             },
    //             {
    //                 "featureType": "water",
    //                 "elementType": "geometry",
    //                 "stylers": [
    //                     {
    //                         "color": "#a2daf2"
    //                     }
    //                 ]
    //             }
    //         ],
    //         {name: 'Styled Map'});



    // this.$refs.mapRef.$mapPromise.then((map) => {
    //   map.mapTypes.set('styled_map', styledMapType);
    //   map.setMapTypeId('styled_map');
    // });
    this.model.campaignInfo.period = this.dropdown[0].value
    this.model.campaignInfo.start = this.aWeekLater
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    async refetchData(){
      this.countRoute= 0
      this.getRoutes()
      this.resetMap()
      await this.loadData()
    },
    async refetchDataSearch(){
      this.countRoute= 0
      this.resetMap()
      await this.loadData()
      this.category = ''
      this.getRoutes()
    },
    async getRoutes(){
      this.isLoading = await true
      try{
        const res = await this.$apollo.query({
          query: require('@/graphql/bus/query/routeListings.gql'),
          variables:{
            search: this.search,
            category: this.category
          },
          loadingKey: 'loading',
          errorPolicy: 'all',
          fetchPolicy: 'network-only',
        })
        if (res.data){
          this.routes = []
          const { routes } = res.data
          if (res.errors){
            this.handleError(res.errors, 'route')
          } else{
            await routes.map(async route => {
              if (route.buses){
                route.buses.map(bus =>{
                  const featuredContent = bus.contents.filter(x => {
                    return x.is_featured
                  })
                  bus.contents = featuredContent
                })
              }
              if (route.generics.length !== 0) {
                await this.routes.push({
                  id: route.id,
                  title: route.title,
                  daily_trip: route.trip,
                  traffic: route.traffic,
                  buses: route.buses,
                  forbiddenAds: route.forbiddenAds,
                  categories: route.category,
                  fileRoute: route.fileRoute.content_url,
                  generics: route.generics,
                  routeDetails: route.routeDetails
                })
              }
            })
            if(this.routes.length < 1) {this.isEmpty = true}
            else {this.isEmpty = false}
            await this.initData()

            this.isLoading = false
          }
        }
      } catch(err){
        this.isLoading = false
        this.$router.push({ name: `500` })
      }
    },
    showErrorNotification(param){
      let text = `Something went wrong. Please refresh the page!`
      switch(param){
        case 'order':
          text = `Item failed added to your order.`
          break;
        case 'continue':
          text = `Failed to Continue. Please Retry!`
          this.isLoadingContinue = false
          break;
        case 'continueOrder':
          text = `Failed to Continue. Please select order!`
          this.isLoadingContinue = false
          break;
      }
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: text,
        type: 'danger'
      });
    },
    showSuccessNotification(param){
      let text = `Item successfully added to your order.`
      this.$notify({
        group: 'saved',
        title: 'Success',
        text: text,
        type: 'success'
      });
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          switch(param){
            case 'route':
              this.countRoute++
              if (this.countRoute<5) {
                await this.getRoutes()
              } else {
                this.showErrorNotification('route')
                this.isLoading = false
              }
              break;
            case 'addCampaign':
              this.countCheckout++
              if (this.countCheckout<3){
                await this.submit()
              } else {
                this.showErrorNotification('continue')
              }
              break;
          }
        }else {
          if (param === 'addCampaign'){
            this.showErrorNotification('continue')
          } else {
            this.$router.push({ name: `500` })
          }
        }
      }
    },
    async selectedPeriod(param){
      let period = param.item.value
      if (period < this.minimumPeriod){
        await this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Minimum period allowed for this campaign is ' + this.minimumPeriod + ' months',
            type: 'danger'
          });
      }
    },
    async getMinimumPeriod(){
      let minPeriod = 0
      await this.order.forEach(async el =>{
        let minPeriodBus = parseInt(el.bus.generic.minPeriod)
        if(minPeriodBus > minPeriod){
          minPeriod = minPeriodBus
        }
      })
      this.minimumPeriod = minPeriod
      if (this.model.campaignInfo.period < minPeriod){
        this.model.campaignInfo.period = minPeriod
      }
    },
    async getMinimumLeadTime(){
      let minLeadTime = 0
      this.order.forEach(el =>{
        let minLeadTimeBus = parseInt(el.generic.leadPreCampaign)
        if(minLeadTimeBus > minLeadTime){
          minLeadTime = minLeadTimeBus
        }
      })
      this.minimumLeadTime = minLeadTime
      this.model.campaignInfo.start
      
    },
    async selectedValue(item){
      let minQuantity = item.generic.minQuantity
      let count = item.count
      if (minQuantity > count){
        item.count = minQuantity
        await this.$notify({
            group: 'saved',
            title: 'Error',
            text: 'Minimum quantity allowed for this campaign is ' + minQuantity,
            type: 'danger'
          });
        
      } 
    },
    async resetMap() {
      if(this.$refs.mapRef){
        this.$refs.mapRef.$mapPromise.then((map) => {
          let w = this.arr[parseInt(this.source)];
          if(w){
            w.setMap(null);
          }
        });
      }
      this.source = null
    },
    async loadData() {

      let data = []

      await this.routes.forEach(kml => {
        const x = new google.maps.KmlLayer(kml.fileRoute,{
          preserveViewport: false
        });
        data.push(x)
      });

      this.arr = await data

    },
    async initData() {
      this.resetMap()
      await this.loadData()
    },
    changeRoute(param) {
      this.source = param.toString()
    },
    openDetail(id) {
      this.isOpenDetail = true;
      this.detailId = id;

      if(window.innerWidth <= 575) {
        this.isOpenDetailMobile = true;
      }

      (async() => {
        const route = await this.routes.find(x => {
          return x.id === id
        })


        let final = []

        const bus = route.generics

        this.details = {
          content: route.buses,
          generics: route.generics
        }

      })();
    },
    closeDetail() {
      this.isOpenDetail = false
      this.picked = null
    },
    getOption(x) {
      return this.options[x].radioOptions
    },
    getDetail() {
      const route = this.routes.filter(x => {
        return x.id == this.detailId
      })
      return route.pop()
    },
    filterCategory(id) {
      this.category = id
      this.isLoading = true
      this.debouncerefetchData()
    },
    menuActive(id) {
      return this.category == id
    },
    async getDataSearch() {
      this.resetMap()
      await this.loadData()
      this.category = ''
    },
    async addOrder() {
      const detail = await this.getDetail()
      const generic = await this.details.generics.filter(x => {
        return x.id == this.picked
      })
      const bus = await this.details.content.filter(x => {
        return x.generic != null && x.generic.id == this.picked
      })

      const data = {
        detail: detail,
        generic: generic.pop(),
        count: 1,
        bus: bus.pop()
      }
      let minQtt = data.generic.minQuantity
      if (minQtt){
        data.count = minQtt
      }
      const order = this.order.map(x => {
        return x.generic.id
      })

      if(order.includes(data.generic.id)){
        const y = this.order.filter(x => {
          return x.generic.id == data.generic.id
        })

        if (y[0].count >= 20) {
          this.showErrorNotification('order')
        }else {
          this.showSuccessNotification('order')
          y[0].count += 1
        }


      } else {
        this.showSuccessNotification('order')
        this.order.push(data)
        this.getMinimumPeriod()
        this.getMinimumLeadTime()
      }

      if(window.innerWidth <= 575) {
        this.isOpenDetailMobile = false
        this.isOpenDetail = false
        this.isOpenSummaryMobile = true
      }

    },
    getTotal(){
      let total = 0
      this.order.forEach(element => {
        const item = element.generic.price * element.count * this.model.campaignInfo.period
        total += item
      });
      return total
    },
    getTotalByPPN(){
      return this.getTotal() + (this.getTotal()*0.1)
    },
    deleteOrder(i) {
      this.order.splice( i, 1 );
      this.getMinimumLeadTime()
      this.getMinimumPeriod()
    },
    async getValueMaxBus() {
      let bus = [...Array(21).keys()].slice(1).map((el) => {
        return {
          label: `${el} Bus`,
          value: el
        }
      })

      this.dropdownBus = await bus
    },
    getRouteByCategory(category) {
      return this.routes.filter((x) => {return x.categories.id == category.id})
    },
    async submit(){
      this.isLoadingContinue = true
      if (this.token) {
        localStorage.setItem('apollo-token', this.token)
        let orders = []
        if (this.order.length > 0 ) {
          this.order.map(order => {
            orders.push({
              count: order.count,
              bus: {
                id: parseInt(order.bus.id)
              }
            })
          })
          try {
            const result = await this.$apollo.mutate({
              mutation: require('@/graphql/bus/mutation/campaignAdd.gql'),
              errorPolicy:'all',
              fetchPolicy:'no-cache',
              variables: {
                input: {
                  campaignInfo: {
                    title: "Untitled",
                    start: moment(this.model.campaignInfo.start).format('YYYY-MM-DD'),
                    period: this.model.campaignInfo.period
                  },
                  orderRoutes: orders
                },
              },
            });
            let id = null
            if (result.data){
              if (result.errors){
                this.handleError(result.errors, 'addCampaign')
              } else {
                const { id } = result.data.createBusCampaign
                if (id){
                  this.isLoadingContinue = false
                  this.$router.push({path: `/bus/campaigneditor/${id}`})
                } else {
                  this.showErrorNotification('continue')
                }
              }
            } else {
              this.showErrorNotification('continue')
            }
          } catch(err) {
            this.showErrorNotification('continue')
          }
        } else {
          this.showErrorNotification('continueOrder')
        }
      } else {
        this.$router.push({name: 'signin', query: { next: this.$route.fullPath }})
      }
    },
    async addMoreOrder () {
      this.isOpenSummaryMobile = false
    },
    async toggleMap() {
      this.isOpenMapMobile = !this.isOpenMapMobile
      this.isOpenDetailMobile = !this.isOpenDetailMobile
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>
<style lang='scss'>

.bus {
.orderSummary__header {
  .selectDropdown {
    .select {
      input {
       pointer-events: none;
      }
    }
  }
}

.orderSummary__content__item__body__left {
  .selectDropdown {
    .select {
      input {
       pointer-events: none;
      }
    }
    .popup {
      max-height: 100px;
      overflow-y: scroll !important;
      width: 100px !important;
    }
  }
  .buscount{
    .popup{
      z-index: 500;
      position: absolute;
      .item{
        padding:0px;
        padding-left: 4px;
      }
    }
  }
}
.orderSummary {
  &__title > h2 {
    font-size: 15px;
  }
  .primary__load {
    position: absolute;
    top: 33%;
    right: 25px;
  }
}
  .item__footer{   
    margin-bottom: 5px;
    margin-top: 5px;
  }

  .font-12{
    font-size: 12px;
    &__weightBold{
      font-size: 12px;
      font-weight: bold;
    }
  }
}
</style>